import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Loader from '../../../../../../../components/sprite/components/loader';
import GmailAddOnSharingDetails from '../../../../gmail-add-on-sharing'
import {
	findLabels,
	getSelectedContactsGroup,
} from '../../../../../../../../actions/contactsGroupItemActions';
import {
	getProfile,
	setActiveLabel,
} from '../../../../../../../../actions/profileActions';
import {getSharingDetailsPopup} from '../../../../../../../../actions/sharingDetailsActions';
import i18n from '../../../../../../../../i18n';
import {I18nextProvider} from 'react-i18next';

class GmailAddonPopupShareLabel extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {loading: true};
	}

	componentDidMount() {
		this.loadLabels();
	}

	loadLabels = () => {
		this.props.FindLabels(undefined, true);
	};

	renderPopUp() {
		if (this.props.checkComponentRendering) {

			let contactId = this.props.location.pathname.split('/');
			contactId = contactId[3];

			/**
			 * Match the Label id from the url to the label list and dispatch a function for selected Group
			 *
			 */
			if (this.props.findLabels.contactsGroups.length === 0 && contactId === '6') {
				this.props.findLabels.systemGroups.filter((systemGroupItem) => {
					if (systemGroupItem.id === '6') {
						this.props.getSelectedContactsGroup(systemGroupItem);
					}
					return null;
				});
				this.props.setActiveLabel('gmail_add_user');
				this.props.getSharingDetailsPopup([true, 'gmail_add_user', 'fromSystemGroupSharing']);
				return <GmailAddOnSharingDetails/>;

			} else {
				this.props.findLabels.contactsGroups.filter((contactsGroupItem) => {
					if (contactsGroupItem.id === contactId) {
						this.props.getSelectedContactsGroup(contactsGroupItem);
					}

					return null;
				});
				this.props.setActiveLabel('gmail_add_user');
				this.props.getSharingDetailsPopup([true, 'gmail_add_user']);

				return <GmailAddOnSharingDetails/>;
			}
		} else {
			return <GmailAddOnSharingDetails/>;
		}
	}

	render() {
		return (
			<I18nextProvider i18n={i18n}>
				{this.props.findLabels === null ? <Loader/> : this.renderPopUp()}
			</I18nextProvider>
		);
	}
}

const mapStateToProps = (state) => ({
	findLabels: state.contactsGroupItemReducer.findLabels,
	language: state.languageReducer.language,
	gmailAddOnContactShare: state.contactsGroupItemReducer.gmailAddOnShareContact,
	setGmailAddOnData: state.profileReducer.setGmailAddOnData,
	checkComponentRendering: state.contactsGroupItemReducer.checkComponentRendering,
	checkActiveGmailAddOnLabel: state.profileReducer.checkActiveGmailAddOnLabel,
	sharingDetailsLv2Popup: state.sharingDetailsReducer.getSharingDetailsLv2Popup,
});

const mapDispatchToProps = (dispatch) => ({
	getSharingDetailsPopup: (array) => {
		dispatch(getSharingDetailsPopup(array));
	},
	FindLabels: (pageSize, directLaunch) => {
		dispatch(findLabels(pageSize, directLaunch));
	},
	getSelectedContactsGroup: (object) => {
		dispatch(getSelectedContactsGroup(object));
	},
	getProfile: (boolean) => dispatch(getProfile(boolean)),
	setActiveLabel: (string) => dispatch(setActiveLabel(string)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(GmailAddonPopupShareLabel)
);
